<template>
    <div>
      <p class="ArticleNormal">
        一代草圣、十里温泉、百里老山、千年银杏、万只白鹭、十万亩国家级森林……这些都是浦口亮眼的标签。南临长江、北枕滁河，坐落在南京市西北部的浦口，是南京绿肺、更是江北明珠。
      </p>
      <p class="ArticleNormal">
        在这六朝古都之中，浦口一呼一吸不仅蕴藏着南方城市的自然之美，同时也浸染着历史与文化的积淀与沧桑，被誉为“都市圈最美花园”。然而突如其来的“黑天鹅”，让浦口的旅游业一度陷入“停摆”状态。
      </p>
      <p class="ArticleNormal">
        随着特殊时期情况的好转，人们一度被“封印”的旅游热情，被重新“点燃”。如何变歇业压力为备战旅游复苏升级的契机，提升城市知名度，成为浦口的重要议题。
      </p>
      <p class="ArticleHead">
        “牵手”IP  备战旅游复苏升级
      </p>
      <p class="ArticleNormal">
        此时，短视频进入了浦口文旅局团队的视野。随着传媒环境发生迭代升级，移动终端成为影响旅游出行最重要信息工具。一条短视频带火一座城不再是神话，抖音堪称城市名片的“种草机”。跟着短视频去旅行成了越来越多人的不二选择。越来越多的游客出行，都是因为在短视频上“种草”，进而“打卡”了该城市。
      </p>
      <p class="ArticleNormal">
        具有创新意识的南京市浦口区文化和旅游局，嗅到了特殊时期背后的“危”与“机”，决定选择以深受用户喜爱的抖音平台作为突破口，牵手巨量引擎的大型城市营销IP“巨量中国•百城计划”，打造一场全民参与的“周末DOU来浦口”的大型营销事件。
      </p>
      <img src="../../../assets/1st/Articles/Article_8/contant_1.jpeg"/>
      <p class="ArticleNormal">
        “巨量中国•百城计划”依托抖音平台优势，希望助力各大城市寻找美好新增量，纵深挖掘城市闪光点和特色元素，以区域挑战赛等形式促进全民互动，为城市政务部门建立与大众的沟通桥梁，助力城市“网红名片”的打造。
      </p>
      <p class="ArticleNormal">
        南京浦口抓住了这波先机，快速决策，在全国首推“巨量中国”，让更多的网友种草诗画田园般的浦口，并记住“都市圈最美花园”的名片。
      </p>
      <p class="ArticleHead">
        深耕诗画浦口特色<br>擦亮“都市圈最美花园”名片
      </p>
      <p class="ArticleNormal">
        首先要考虑的，就是浦口的传播定位。厦门有鼓浪屿岛上的土耳其冰淇淋，西安有落雁塔下的不倒翁小姐姐。显然，要让一个城市被记住，那首先需要挖掘出这个城市最具特色的元素，那浦口让人看到不想走的又是什么？
      </p>
      <p class="ArticleNormal">
        经过深度的挖掘，此次活动围绕着“山水之美、人文之美、乡村之美、舌尖之美四个方面”，将浦口“都市圈最美花园”的特色强化放大。找准了定位和目标，如何才能快速吸引关注度？
      </p>
      <p class="ArticleNormal">
        巨量中国为浦口设计了一套流量引爆的方案。一方面，利用明星的流量效应以及粉丝效应，邀请到张继科、弦子、刘钧、郑合惠子等明星达人城市星推官，为浦口打call，助力其影响力突破区域的限制。
      </p>
      <p class="ArticleNormal">
        另一方面，活动邀请到了粉丝百万级别头部文旅创作者来到浦口，沉浸式地体验浦口的“诗情画意”。@房琪kiki 用清新的语言风格和画面勾勒出浦口珍七路的轮廓：阳光、微风、青草地、随手就能拍出海报质感的院落。这让浦口亲近自然、悠然文艺而闲适的形象跃然纸上。
      </p>
      <video src="../../../assets/1st/Articles/Article_8/video_1.mp4" controls poster="../../../assets/1st/Articles/Article_8/poster_1.jpg"></video>
      <p class="ArticleNormal">
        而@秦鹏P的话 则为粉丝打造了一份详尽的浦口自驾攻略。在他的镜头之下，舒适的日式汤泉、最美小镇不老村、四方当代美术馆等等成为了周末小憩的绝佳去处。同时，活动还邀请到@大熊叔叔-江浙沪周边游 、@北川婠婠、@一只蓝鲸等本地的知名达人，从本地人的视角记录了这里的美好与浪漫。
      </p>
      <p class="ArticleNormal">
        除了线上的集中引爆，在五一”节前，浦口“趁热打铁”，成功举办2020首届南京老山国际文化旅游节暨云音乐节开幕式，推出四季主题旅游产品、16条主题线路、54项旅游节事等。
      </p>
      <p class="ArticleNormal">
        为了调动全民参与“周末dou来浦口”，活动发起全民任务的模式，只要粉丝以“秀美景、晒美食、讲故事”的形式参与到话题中，即有机会获得南京浦口14个景点的联票。
      </p>
      <p class="ArticleNormal">
        最终，#周末dou来浦口 话题播放量高达4.4亿次+，共有6000多条视频参与该挑战，其中达人发布视频30余条播放量超2000万，3支《这就是浦口》城市影像片和挑战赛参与视频总互动数达12.8万。
      </p>
      <p class="ArticleHead">
        局长上阵变身主播<br>
        创新城市形象传播手段
      </p>
      <p class="ArticleNormal">
        值得一提的是，南京市浦口区文化和旅游局局长程媛还亲自上阵，走进了抖音直播间，联动本地达人@菲哥一张嘴，一路游览了四方当代艺术湖区、珍七路、不老村，通过在线上带领网友粉丝以“云游览”形式欣赏了浦口美景。
      </p>
      <p class="ArticleNormal">
        据统计，整场直播在线观看人数1万余人次，文旅浦口抖音号当天播放量达160余万次。整个活动期间，⽂旅浦⼝涨粉2.7万，有效的拉近了城与人的距离，迅速攒聚了用户高关注，实现了对当地用户的深度种草。
      </p>
      <p class="ArticleNormal">
        通过这次“牵手”，浦口旅游市场迅速回暖。虽然浦口各大景区疫情期间为加强防控，确保有序开放，实行了参观预约制，严格流量管控，但游客数量同比增长仍然达到了50%，多家小众景区也迎来了参观热潮。
      </p>
      <p class="ArticleNormal">
        显然。对于浦口来说，参与到巨量引擎大型城市巡礼IP项目“巨量中国·百城计划”从而进行了以上种种尝试，正是参与到一场内容风暴、互动浪潮、流量盛宴当中，打开了形象传播的新大门。
      </p>
      <p class="ArticleHead">
        网红城市名片背后<br>
        IP势能加持 助力乘风破浪
      </p>
      <p class="ArticleNormal">
        其实，除了南京浦口，巨量中国还相继助力宁夏、甘肃兰州、辽宁沈阳、江苏常熟、武汉光谷等多个城市打造了亮眼的城市名片。巨量引擎营销中心整合营销高级总监李艳杰介绍道，城市形象传播是巨量引擎一直在发力的方向，巨量中国希望将各地城市的力量汇聚起来，打造一份城市名片的图谱。截止日前，#巨量中国 相关话题播放量已经近18亿，未来也将会让更多城市的美好在抖音被放大，被看见。
      </p>
      <div>
        <img class="Img5" src="../../../assets/1st/Articles/Article_8/contant_2.jpg"/>
        <img class="Img5" src="../../../assets/1st/Articles/Article_8/contant_3.jpg"/>
        <img class="Img5" src="../../../assets/1st/Articles/Article_8/contant_4.jpg"/>
        <img class="Img5" src="../../../assets/1st/Articles/Article_8/contant_5.jpg"/>
        <img class="Img5" src="../../../assets/1st/Articles/Article_8/contant_6.jpg"/>
      </div>
      <p class="ArticleNormal">
        数十亿的传播声量，离不开每个美好城市潜在的张力与传播力。但为何有的城市短视频营销只是激起几个小水花，热度转瞬即逝，而#巨量中国 的系列活动却能掀起一股美好城市的浪潮？
      </p>
      <p class="ArticleNormal">
        在巨量引擎江苏分公司总经理张雁飞看来，背后城市IP营销手段，是不能忽视的原因。
      </p>
      <p class="ArticleNormal">
        张雁飞认为，IP化对城市形象传播的驱动价值是不可估量的，有效的运营能实现城市、平台、消费者三赢的局面，提升城市的传播度与形象好感度。其核心价值主要体现在三个方面：
      </p>
      <p class="ArticleNormal">
        首先，平台的IP活动，对于城市形象的包装具有很强的短期拉动效应。好的IP，能快速有效地聚合流量，形成规模效应。浦口这次通过抖音平台开屏、信息流、多元组件等流量产品，在短短一周之内，就收割了4.4亿的关注度，有效配合活动提升城市品牌曝光。
      </p>
      <p class="ArticleNormal">
        除了巨量中国，巨量引擎还孵化了抖inCity城市美好生活节、巨量系列、美好系列等多个IP项目。这些高价值、高信息密度、创新型的项目往往能有效引起行业以及媒体关注，甚至引发多次的传播。
      </p>
      <p class="ArticleNormal">
        其次，IP对城市形象传播是一种创新的手段，能起到引领潮流的作用。传统的城市形象传播主要依托于电视、门户网站、户外大牌等传统的渠道，难以有效的量化效果，互动性也较弱，评估维度单一。“而IP类项目的优势在于能有效的整合各个渠道的资源，最大化地实现声量的引爆。”张雁飞举例道，浦口的活动不仅联动了抖音线上的开屏、信息流等王牌资源，同时引入全民任务、直播等多元化的模式，调动全民的积极性。在线下，更是举办首届南京老山国际文化旅游节，最终实现线上线下的联动与反哺。
      </p>
      <p class="ArticleNormal">
        另外，IP活动能激发政府文旅部门灵感，助力城市形象传播工作者把握前瞻玩法，更好地掌握主流传播趋势。从浦口这个项目中，可以明显的看到城市传播的诉求明显发生了改变，“大曝光、单向度的传播已经成为过去。而如何吸引年轻人，如何更精准的覆盖目标用户成为新的诉求。”
      </p>
      <p class="ArticleNormal">
        在巨量引擎，经过多年的探索，已经沉淀出一套爆款IP可复制的打法。但不是每一个城市都会成为下一个“西安”。打磨过多次的“爆款套路”必须结合具体城市的特点，才能真正点燃引爆的路径，从而撬动更大的传播声量。
      </p>
    </div>
</template>

<script>
    export default {
        name: "Article8"
    }
</script>

<style scoped>
  img{
    width: 100%;
  }
  video{
    width: 100%;
  }
  .Img5{
    width: 20%;
    display: block;
    float: left;
    margin-bottom: 3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/Articles/Article8.vue